import { render } from "./WarehouseItemsList.vue?vue&type=template&id=bbb247e0"
import script from "./WarehouseItemsList.vue?vue&type=script&lang=js"
export * from "./WarehouseItemsList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__